<template>
  <div
    class="changed-item"
    :class="{ isEnglish: $isEnglish }"
  >
    <div class="con clearfix">
      <not-can-edit
        :data="data"
        class="fl"
        :class="data.fieldtype + '-wrap'"
      />
      <a
        class="fl del-btn fs-blue"
        @click="handleDelete"
      >
        {{ $t('message["962"]') }}
      </a>
    </div>
    <div class="fs-warning tip">
      {{ $t('message["332"]') }}
    </div>
  </div>
</template>

<script>
import NotCanEdit from './NotCanEdit'

export default {
  components: {
    NotCanEdit
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      value: ''
    }
  },
  methods: {
    handleDelete () {
      this.$emit('delete')
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-btn {
  margin: 0 16px;
}
.changed-item {
  position: relative;
  padding-bottom: 36px;
  .ant-form-item {
    margin-bottom: 0;
  }
}
.tip {
  position: absolute;
  bottom: 16px;
  padding-left: 140px;
  font-size: 12px;
}
.del-btn {
  height: 32px;
  line-height: 32px;
  margin-left: 16px;
  color: #5077aa;
}
.editor-wrap {
  width: 84%;
}
/* .not-edit-item {
  width: 84%;
} */
.isEnglish {
  .tip {
    padding-left: 200px;
  }
}
</style>
